import { ReportStatusComponent } from './report-status.component';

export default angular
  .module('sfMobile.components.report-status', [])
  .component('sfReportStatus', ReportStatusComponent).name;
